import { render } from "./IPDescription.vue?vue&type=template&id=1d6160e8&ts=true"
import script from "./IPDescription.vue?vue&type=script&lang=ts"
export * from "./IPDescription.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__